import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ProvisionService } from "../../../shared/services/api/provisoes/ProvisionService";
import { SinisterService } from "../../../shared/services/api/sinister/SinisterService";
import { userService } from "../../../shared/services/api/user/userService";

export function useSinisterSummary(id: string) {
	const navigate = useNavigate();
	const [isLoading, setIsLoading] = useState(true);
	const [rowSummary, setRowSummary] = useState<any>(null);
	const [responsibleName, setResponsibleName] = useState("");
	const [rowUser, setRowUser] = useState<any>(null);
	const [totalBordero, setTotalBordero] = useState(0);

	const fetchSinisterData = useCallback(async () => {
		if (!id) return;

		setIsLoading(true);

		const result = await SinisterService.getById(id);

		if (result instanceof Error) {
			alert(result.message);
			navigate("/sinister");
			return;
		}

		const { id: sinisterId, responsibleId } = result;

		setRowSummary(result);

		if (responsibleId) {
			const resultUser = await userService.getByID(responsibleId);
			if (!(resultUser instanceof Error)) {
				setRowUser(resultUser);
				setResponsibleName(resultUser.name);
			}
		}

		if (sinisterId) {
			const resultCount: any = await ProvisionService.countBordero(sinisterId);
			if (!(resultCount instanceof Error)) {
				setTotalBordero(Number(resultCount));
			}
		}

		setIsLoading(false);
	}, [id, navigate]);

	useEffect(() => {
		fetchSinisterData();
	}, [fetchSinisterData]);

	return {
		isLoading,
		rowSummary,
		responsibleName,
		rowUser,
		totalBordero,
		refetch: fetchSinisterData,
	};
}
